<template>
  <f7-page id="page-sendmoney-contribution-table" name="sendmoney-contribution-table" @page:init="getPhilGovContributionlist();" @page:afterin="afterin();">
    <f7-navbar class="no-border view-mobile">
      <div class="navbar-inner">
        <f7-nav-left class="back-button">
          <f7-link icon-f7="chevron_left" @click="handleBackButton()" color="black"></f7-link>
        </f7-nav-left>
        <f7-nav-right>
          <f7-link></f7-link>
        </f7-nav-right>
      </div>
    </f7-navbar>

    <f7-block>
      <div class="wandr-level-4">SSS Contribution Table</div>
    </f7-block>
    <f7-block class="card-container card-10">
      <div class="data-table">
        <table class="contribution-table">
          <thead>
            <tr class="text-align-center text-color-black">
              <th colspan="2">Range of Compensation</th>
              <th>Monthly <br/>Contribution</th>
              <th>Mandatory <br/>Provident Fund</th>
              <th>Total Monthly <br/>Contribution</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in contributionList" :key="item.id" >
              <td v-if="item.id == 36 || item.id == 80" colspan="2">{{item.rangeOfCompensation}}</td>
              <td v-if="item.id > 36 && item.id != 80">{{ formatCurrency(item.compensationStart,2)}}</td>
              <td v-if="item.id > 36 && item.id != 80">{{ formatCurrency(item.compensationEnd,2)}}</td>
              <td>{{ formatCurrency(item.monthlyContribution,2) }}</td>
              <td>{{ (item.mandatoryProvidentFund > 0) ? formatCurrency(item.mandatoryProvidentFund,2) : ''}}</td>
              <td>{{ formatCurrency(item.totalMonthlyContribution,2) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </f7-block>

  </f7-page>
</template>

<script>
  import { mapGetters, mapActions } from "vuex"

  export default {
    data() {
			return {

        contributionList : [],

			}
		},
    mounted(){
      // Required for everypage. Toggle desktop-view footer.
      this.toggleFooterVisibility(false)
      this.$f7.$('.page-content').on('scroll', (e) => {
        this.toggleFooterVisibility(e.target)
      })
    },
		computed: {
			...mapGetters('auth', [
				'authenticating',
				'authenticationError',
				'authenticationErrorCode',
				'authenticationSuccess'
			])
		},

    methods: {
      ...mapActions('auth', ['login']),

      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },

      getPhilGovContributionlist(){
        const self = this
        self.showPreloader()
        const getPhilGovContributionPromise = self.$api.transaction.getPhilGovContributionlist()
        getPhilGovContributionPromise.then(function(result) {
          self.contributionList = result
          self.hidePreloader()
        })
      },

      formatCurrency(num, dec) {
        let val = (Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100).toFixed(dec)
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },

      handleBackButton(){
        this.$f7router.back({ transition: 'f7-push' })
      },
    }
  }
</script>